module.exports = __webpack_public_path__ + "img/top-up-is-delayed.ec64448.svg";